// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"322":"4839a770","409":"99fcc52c","940":"99fcc52c"}[chunkId] + ".chunk.css";
};